(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["tsr-article"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function videoSrc(href) {
      var m = href.match(/(?:youtube\.com\/(?:watch\?v=|shorts\/|live\/)|youtu\.be\/)([\w-]{6,})/i);
      if (m) return 'https://www.youtube-nocookie.com/embed/' + m[1] + '?rel=0';
      m = href.match(/vimeo\.com\/(?:video\/)?(\d+)(?:\/(\w+))?/i);
      if (m) return 'https://player.vimeo.com/video/' + m[1] + (m[2] ? '?h=' + m[2] : '');
      return null;
    }
    var FILE_RE = /\.(zip|rar|wav|aif|aiff|mp3|flac|pdf|adg|adv|amxd|als|alp|fxp|nmsv|mid|midi)(\?|$)/i;

    var MEDIA = 'iframe, video, img, .tsr-yt, .tsr-post__embed';
    function isEmpty(el) {
      return el && el.nodeType === 1 && !el.matches(MEDIA) && !el.querySelector(MEDIA) &&
        el.textContent.replace(/[\s\u00a0\u200b]/g, '') === '';
    }
    function trim(box, fromEnd) {
      var el;
      while ((el = fromEnd ? box.lastElementChild : box.firstElementChild) && isEmpty(el) && !el.querySelector('a')) el.remove();
    }
    function onlyDownloads(el) {
      var dl = el.querySelectorAll('a.tsr-post__dl');
      if (!dl.length) return false;
      var t = el.textContent;
      dl.forEach(function (a) { t = t.replace(a.textContent, ''); });
      return t.replace(/[\s\u00a0\u00b7|,\-–—·]/g, '') === '';
    }
    function split(rte) {
      if (rte.classList.contains('is-split')) return;
      var text = document.createElement('div'); text.className = 'tsr-post__item-text';
      var media = document.createElement('div'); media.className = 'tsr-post__item-media';
      var inMedia = false;
      Array.prototype.slice.call(rte.childNodes).forEach(function (n) {
        if (!inMedia && n.nodeType === 1 && (n.matches(MEDIA) || n.querySelector(MEDIA) || onlyDownloads(n))) inMedia = true;
        if (n.nodeType === 3 && !n.textContent.trim()) { n.remove(); return; }
        (inMedia ? media : text).appendChild(n);
      });
      trim(text, false); trim(text, true); trim(media, false); trim(media, true);
      rte.appendChild(text); rte.appendChild(media);
      rte.classList.add('is-split');
    }

    function enhance(root) {
      (root || document).querySelectorAll('[data-tsr-post] .tsr-post__rte').forEach(function (rte) {
        if (rte.__tsrDone) return;
        rte.__tsrDone = true;
        // A YouTube / Vimeo link on its own line becomes a player
        rte.querySelectorAll('a[href]').forEach(function (a) {
          var src = videoSrc(a.getAttribute('href'));
          if (!src) return;
          var p = a.closest('p, div');
          var alone = p && p !== rte && p.textContent.trim() === a.textContent.trim();
          if (!alone) return;
          var f = document.createElement('iframe');
          f.src = src; f.className = 'tsr-post__embed'; f.loading = 'lazy'; f.title = a.textContent.trim() || 'Video';
          f.allow = 'accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture; fullscreen'; f.allowFullscreen = true;
          p.replaceWith(f);
        });
        // A bare video URL typed as plain text on its own line
        rte.querySelectorAll('p').forEach(function (p) {
          if (p.children.length) return;
          var t = p.textContent.trim();
          if (!/^https?:\/\/\S+$/.test(t)) return;
          var src = videoSrc(t);
          if (!src) return;
          var f = document.createElement('iframe');
          f.src = src; f.className = 'tsr-post__embed'; f.loading = 'lazy'; f.title = 'Video';
          f.allow = 'accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture; fullscreen'; f.allowFullscreen = true;
          p.replaceWith(f);
        });
        // Links to files become download buttons
        rte.querySelectorAll('a[href]').forEach(function (a) {
          var h = a.getAttribute('href') || '';
          if (FILE_RE.test(h) || /cdn\.shopify\.com\/.*\/files\//i.test(h) || /\/cdn\/shop\/files\//i.test(h)) {
            a.classList.add('tsr-post__dl');
            a.setAttribute('download', '');
          }
        });
        // Split each item into text (before the first video, image or row of download buttons) and media (from it onwards),
        // so the grid can line the media up across a row
        if (rte.classList.contains('tsr-post__item-body')) split(rte);
      });
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { enhance(); });
    else enhance();
    document.addEventListener('shopify:section:load', function (e) { enhance(e.target); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tsr-faq"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (window.__tsrFaq) return;
    window.__tsrFaq = true;
    var mq = window.matchMedia('(max-width: 749px)');

    function setup(sec) {
      var mode = sec.getAttribute('data-mode');
      var items = sec.querySelectorAll('.tsr-faq__q');
      if (mode === 'open') {
        items.forEach(function (d) { d.open = true; });
      } else if (mode === 'mobile') {
        var first = parseInt(sec.getAttribute('data-open-first') || '1', 10);
        items.forEach(function (d, i) { d.open = mq.matches ? i < first : true; });
      }
    }
    function scan(root) { (root || document).querySelectorAll('[data-tsr-faq]').forEach(setup); }

    // Keep answers open where they must stay open
    document.addEventListener('click', function (e) {
      var sum = e.target.closest('.tsr-faq__summary');
      if (!sum) return;
      var sec = sum.closest('[data-tsr-faq]');
      var mode = sec && sec.getAttribute('data-mode');
      if (mode === 'open' || (mode === 'mobile' && !mq.matches)) e.preventDefault();
    });

    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { scan(); });
    else scan();
    if (mq.addEventListener) mq.addEventListener('change', function () { scan(); });
    document.addEventListener('shopify:section:load', function (e) { scan(e.target); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tsr-film"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (window.__tsrFilm) return;
    window.__tsrFilm = true;

    function pad(n) { return (n < 10 ? '0' : '') + n; }
    function code(t, fps) {
      var f = Math.floor((t % 1) * fps), s = Math.floor(t);
      return pad(Math.floor(s / 3600)) + ':' + pad(Math.floor(s / 60) % 60) + ':' + pad(s % 60) + ':' + pad(f);
    }

    function init(sec) {
      if (sec.__tsrFilmReady) return;
      sec.__tsrFilmReady = true;
      var ring = sec.querySelector('.tsr-film__ring[data-fit]');
      if (ring) { fitRing(ring); if (document.fonts && document.fonts.ready) document.fonts.ready.then(function () { fitRing(ring); }); }

      var tc = sec.querySelector('[data-tsr-timecode]');
      var bar = sec.querySelector('[data-tsr-progress]');
      var fps = parseInt(sec.getAttribute('data-fps'), 10) || 25;
      var live = sec.getAttribute('data-timecode') === 'live';
      var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      var visible = false, start = null, raf = null;

      function tick(now) {
        raf = null;
        var v = sec.classList.contains('is-playing') ? sec.querySelector('.tsr-film__full, .tsr-film__preview') : null;
        if (v && !v.paused && v.duration) {
          if (tc) tc.textContent = code(v.currentTime, fps);
          if (bar) bar.style.width = (v.currentTime / v.duration * 100).toFixed(2) + '%';
        } else if (live && tc && !reduce && !sec.classList.contains('is-playing')) {
          if (start === null) start = now;
          tc.textContent = code((now - start) / 1000, fps);
        }
        if (visible) raf = requestAnimationFrame(tick);
      }
      if ('IntersectionObserver' in window) {
        new IntersectionObserver(function (entries) {
          visible = entries[0].isIntersecting;
          if (visible && !raf) raf = requestAnimationFrame(tick);
        }).observe(sec);
      }
    }

    function fitRing(svg) {
      var t = svg.querySelector('text'), circ = parseFloat(svg.getAttribute('data-fit'));
      if (!t || !circ) return;
      t.setAttribute('letter-spacing', '0');
      var len = t.getComputedTextLength(), n = (t.textContent || '').length;
      if (len > 0 && n > 0) t.setAttribute('letter-spacing', ((circ - len) / n).toFixed(3));
    }

    function scan(root) { (root || document).querySelectorAll('[data-tsr-film]').forEach(init); }

    // Fit the playing film snugly to its own shape, centred, so no black bars show at the sides
    function tighten(sec, el, ratio) {
      if (el) el.classList.add('is-live');
      if (!sec.classList.contains('tsr-film--play-tight') || !el || !ratio) return;
      var frame = sec.querySelector('.tsr-film__frame');
      function size() {
        var fw = frame.clientWidth, fh = frame.clientHeight;
        if (!fw || !fh) return;
        var w = Math.min(fw, fh * ratio), h = Math.min(fh, fw / ratio);
        el.style.inset = 'auto';
        el.style.width = w + 'px'; el.style.height = h + 'px';
        el.style.left = ((fw - w) / 2) + 'px'; el.style.top = ((fh - h) / 2) + 'px';
      }
      size();
      if (!el.__tsrTight) { el.__tsrTight = true; window.addEventListener('resize', size); }
    }
    function tightenVideo(sec, v) {
      if (!v) return;
      v.classList.add('is-live');
      var go = function () { if (v.videoWidth) tighten(sec, v, v.videoWidth / v.videoHeight); };
      if (v.readyState >= 1) go(); else v.addEventListener('loadedmetadata', go, { once: true });
    }

    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-tsr-film-play]');
      if (!btn) return;
      var sec = btn.closest('[data-tsr-film]');
      var frame = sec && sec.querySelector('.tsr-film__frame');
      if (!frame) return;
      var full = frame.querySelector('.tsr-film__full');
      var src = frame.getAttribute('data-embed');
      var preview = frame.querySelector('.tsr-film__preview');
      if (full) {
        if (preview) preview.pause();
        full.controls = true;
        sec.classList.add('is-playing');
        tightenVideo(sec, full);
        full.play();
      } else if (src) {
        var iframe = document.createElement('iframe');
        iframe.src = src;
        iframe.allow = 'autoplay; fullscreen; picture-in-picture';
        iframe.allowFullscreen = true;
        iframe.title = btn.getAttribute('aria-label') || 'Film';
        frame.appendChild(iframe);
        sec.classList.add('is-playing');
        tighten(sec, iframe, 16 / 9);
      } else if (preview) {
        preview.currentTime = 0;
        preview.muted = false;
        preview.loop = false;
        preview.controls = true;
        sec.classList.add('is-playing');
        tightenVideo(sec, preview);
        preview.play();
      }
    });

    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { scan(); });
    else scan();
    document.addEventListener('shopify:section:load', function (e) { scan(e.target); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tsr-header"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (customElements.get('tsr-header')) return;

    class TsrHeader extends HTMLElement {
      connectedCallback() {
        this.bar = this.querySelector('.tsr-header__bar');
        this.drawer = this.querySelector('.tsr-header__drawer');
        this.openBtn = this.querySelector('[data-tsr-menu-open]');
        this.closeBtn = this.querySelector('[data-tsr-menu-close]');
        this.hideOnScroll = this.dataset.hideOnScroll === 'true';
        this.threshold = parseInt(this.dataset.scrollThreshold || '10', 10);
        this.lastY = window.scrollY;

        this.onScroll = this.onScroll.bind(this);
        this.onKey = this.onKey.bind(this);
        this.open = this.open.bind(this);
        this.close = this.close.bind(this);

        window.addEventListener('scroll', this.onScroll, { passive: true });
        if (this.openBtn) this.openBtn.addEventListener('click', this.open);
        if (this.closeBtn) this.closeBtn.addEventListener('click', this.close);
        this.drawer && this.drawer.querySelectorAll('a').forEach((a) => a.addEventListener('click', this.close));

        if ('ResizeObserver' in window) {
          this.ro = new ResizeObserver(() => this.measure());
          this.ro.observe(this.bar);
        }
        this.measure();
        this.onScroll();
      }

      disconnectedCallback() {
        window.removeEventListener('scroll', this.onScroll);
        document.removeEventListener('keydown', this.onKey);
        if (this.ro) this.ro.disconnect();
        document.documentElement.style.overflow = '';
      }

      measure() {
        document.documentElement.style.setProperty('--tsr-header-height', this.bar.offsetHeight + 'px');
      }

      onScroll() {
        const y = window.scrollY;
        this.classList.toggle('is-scrolled', y > this.threshold);
        if (this.hideOnScroll && !this.classList.contains('is-open')) {
          const goingDown = y > this.lastY;
          this.classList.toggle('is-hidden', goingDown && y > this.bar.offsetHeight * 2);
        }
        this.lastY = y;
      }

      open() {
        this.classList.add('is-open');
        this.drawer.removeAttribute('inert');
        this.openBtn.setAttribute('aria-expanded', 'true');
        document.documentElement.style.overflow = 'hidden';
        document.addEventListener('keydown', this.onKey);
        const first = this.drawer.querySelector('a, button');
        if (first) first.focus();
      }

      close() {
        this.classList.remove('is-open');
        this.drawer.setAttribute('inert', '');
        this.openBtn.setAttribute('aria-expanded', 'false');
        document.documentElement.style.overflow = '';
        document.removeEventListener('keydown', this.onKey);
        this.openBtn.focus();
      }

      onKey(e) {
        if (e.key === 'Escape') this.close();
      }
    }

    customElements.define('tsr-header', TsrHeader);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tsr-hero"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (window.__tsrHeroFit) return;
    window.__tsrHeroFit = true;

    // Shrinks the vertical words (never enlarges) so the tallest one fits the space available.
    function fit(hero) {
      if (!hero.classList.contains('tsr-hero--fit')) { hero.style.setProperty('--vw-fit', 1); return; }
      var group = hero.querySelector('.tsr-hero__words');
      if (!group) return;
      hero.style.setProperty('--vw-fit', 1);
      var words = group.querySelectorAll('.tsr-vw');
      var tallest = 0;
      for (var i = 0; i < words.length; i++) {
        if (words[i].offsetParent === null) continue;
        tallest = Math.max(tallest, words[i].getBoundingClientRect().height);
      }
      if (!tallest) return;
      var mobile = window.matchMedia('(max-width: 749px)').matches;
      var cs = getComputedStyle(hero.querySelector('.tsr-hero__content'));
      var available;
      if (mobile) {
        var share = parseFloat(getComputedStyle(hero).getPropertyValue('--words-max-m')) || 50;
        available = hero.clientHeight * share / 100;
      } else {
        available = hero.clientHeight - parseFloat(cs.paddingTop) - parseFloat(cs.paddingBottom);
      }
      var scale = Math.min(1, available / tallest);
      hero.style.setProperty('--vw-fit', scale.toFixed(4));
    }

    function fitAll() {
      document.querySelectorAll('.tsr-hero').forEach(fit);
    }

    var t;
    function queue() { clearTimeout(t); t = setTimeout(fitAll, 60); }

    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fitAll); else fitAll();
    window.addEventListener('resize', queue);
    window.addEventListener('load', fitAll);
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(fitAll);
    document.addEventListener('shopify:section:load', queue);
    document.addEventListener('shopify:block:select', queue);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tsr-membership"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function order(root) {
      (root || document).querySelectorAll('.tsr-plans__grid').forEach(function (g) {
        var cards = g.querySelectorAll('.tsr-plan');
        for (var i = 0; i < cards.length; i++) cards[i].style.setProperty('--tsr-order', i);
      });
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { order(); });
    else order();
    document.addEventListener('shopify:section:load', function (e) { order(e.target); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tsr-password"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function setup(root) {
      (root || document).querySelectorAll('[data-tsr-pw]').forEach(function (sec) {
        if (sec.__tsrPw) return;
        sec.__tsrPw = true;
        var dlg = sec.querySelector('.tsr-pw__dialog');
        var opener = sec.querySelector('[data-tsr-pw-open]');
        if (!dlg) return;
        function open() {
          if (typeof dlg.showModal === 'function') { if (!dlg.open) dlg.showModal(); } else dlg.setAttribute('open', '');
          var f = dlg.querySelector('input[type="password"]'); if (f) setTimeout(function () { f.focus(); }, 30);
        }
        function close() { if (typeof dlg.close === 'function') dlg.close(); else dlg.removeAttribute('open'); if (opener) opener.focus(); }
        if (opener) opener.addEventListener('click', open);
        sec.querySelectorAll('[data-tsr-pw-close]').forEach(function (b) { b.addEventListener('click', close); });
        // Click outside the box closes it
        dlg.addEventListener('click', function (e) { if (e.target === dlg) close(); });
        // Wrong password, or a link to /password#password: open the box straight away
        if (sec.querySelector('[data-tsr-pw-error]') || location.hash === '#password') open();
      });
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { setup(); });
    else setup();
    document.addEventListener('shopify:section:load', function (e) { setup(e.target); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tsr-product"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function setup(root) {
      (root || document).querySelectorAll('[data-tsr-prod]').forEach(function (sec) {
        if (sec.__tsrProd) return;
        sec.__tsrProd = true;
        var tabs = Array.prototype.slice.call(sec.querySelectorAll('[data-tier-tab]'));
        var panels = sec.querySelectorAll('[data-tier-panel]');
        var media = sec.querySelectorAll('[data-tier-media]');

        // Stagger the hidden tiers' items like the first one, so the entrance looks the same whichever tier shows
        var first = panels[0];
        if (first) {
          var all = Array.prototype.slice.call(sec.querySelectorAll('[data-tsr-item]'));
          var base = all.indexOf(first.querySelector('[data-tsr-item]'));
          if (base > -1) panels.forEach(function (p) {
            p.querySelectorAll('[data-tsr-item]').forEach(function (it, i) { it.style.setProperty('--tsr-i', base + i); });
          });
        }

        function show(n, focus) {
          n = String(n);
          tabs.forEach(function (t) {
            var on = t.getAttribute('data-tier-tab') === n;
            t.setAttribute('aria-selected', on ? 'true' : 'false');
            t.setAttribute('tabindex', on ? '0' : '-1');
            if (on && focus) t.focus();
          });
          panels.forEach(function (p) { var on = p.getAttribute('data-tier-panel') === n; p.hidden = !on; p.classList.toggle('is-active', on); });
          media.forEach(function (m) { var on = m.getAttribute('data-tier-media') === n; m.hidden = !on; m.classList.toggle('is-active', on); });
        }
        sec.__tsrShow = show;

        tabs.forEach(function (t, i) {
          t.addEventListener('click', function () { sec.classList.add('is-switched'); show(t.getAttribute('data-tier-tab')); });
          t.addEventListener('keydown', function (e) {
            var k = e.key, j = -1;
            if (k === 'ArrowRight' || k === 'ArrowDown') j = (i + 1) % tabs.length;
            else if (k === 'ArrowLeft' || k === 'ArrowUp') j = (i - 1 + tabs.length) % tabs.length;
            else if (k === 'Home') j = 0;
            else if (k === 'End') j = tabs.length - 1;
            if (j < 0) return;
            e.preventDefault();
            sec.classList.add('is-switched');
            show(tabs[j].getAttribute('data-tier-tab'), true);
          });
        });

        // ?tier=insider or #insider opens that tier
        try {
          var want = decodeURIComponent(new URLSearchParams(location.search).get('tier') || location.hash.slice(1) || '').toLowerCase().trim();
          if (want) {
            var hit = null;
            // ?tier=1 / ?tier=2 picks by position; otherwise match the tier name, the switch label, or part of either
            if (/^\d+$/.test(want)) hit = tabs[parseInt(want, 10) - 1] || null;
            if (!hit) tabs.forEach(function (t) { if (!hit && t.getAttribute('data-key') === want) hit = t; });
            if (!hit) tabs.forEach(function (t) {
              var k = (t.getAttribute('data-key') || '') + ' ' + t.textContent.toLowerCase();
              if (!hit && k.indexOf(want) > -1) hit = t;
            });
            if (hit) { sec.classList.add('is-loading'); show(hit.getAttribute('data-tier-tab')); setTimeout(function () { sec.classList.remove('is-loading'); }, 50); }
          }
        } catch (e) {}

        // Join: empty the cart (optional), add this tier with its plan, then go to checkout
        sec.querySelectorAll('form[data-tsr-join]').forEach(function (form) {
          form.addEventListener('submit', function (e) {
            if (!window.fetch) return;
            e.preventDefault();
            var btn = form.querySelector('button[type="submit"]');
            var label = btn && btn.querySelector('[data-label]');
            var old = label ? label.textContent : '';
            var err = form.querySelector('.tsr-prod__error');
            if (btn) { btn.setAttribute('aria-busy', 'true'); btn.disabled = true; }
            if (label && sec.getAttribute('data-adding')) label.textContent = sec.getAttribute('data-adding');
            if (err) err.hidden = true;
            var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
            var item = { id: Number(form.elements.id.value), quantity: 1 };
            if (form.elements.selling_plan) item.selling_plan = Number(form.elements.selling_plan.value);
            var clear = String(sec.getAttribute('data-clear-cart')).toLowerCase() === 'true'
              ? fetch(root + 'cart/clear.js', { method: 'POST', headers: { 'Content-Type': 'application/json' } })
              : Promise.resolve();
            clear.then(function () {
              return fetch(root + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ items: [item] }) });
            }).then(function (r) {
              if (!r.ok) throw new Error('add');
              location.href = sec.getAttribute('data-after-add') === 'cart' ? root + 'cart' : '/checkout';
            }).catch(function () {
              if (btn) { btn.removeAttribute('aria-busy'); btn.disabled = false; }
              if (label) label.textContent = old;
              if (err) err.hidden = false;
            });
          });
        });
      });
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { setup(); });
    else setup();
    document.addEventListener('shopify:section:load', function (e) { setup(e.target); });
    // In the theme editor, selecting a tier block shows that tier
    document.addEventListener('shopify:block:select', function (e) {
      var sec = e.target.closest && e.target.closest('[data-tsr-prod]');
      var tab = e.target.getAttribute && e.target.getAttribute('data-tier-tab');
      if (sec && sec.__tsrShow && tab) sec.__tsrShow(tab);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tsr-tier"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (window.__tsrTierPlay) return;
    window.__tsrTierPlay = true;
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-tsr-play]');
      if (!btn) return;
      var box = btn.closest('.tsr-tier__media-inner');
      if (!box) return;
      var video = box.querySelector('video');
      if (video) {
        video.controls = true;
        video.muted = false;
        video.play();
        box.classList.add('is-playing');
        return;
      }
      var src = box.getAttribute('data-embed');
      if (src) {
        var iframe = document.createElement('iframe');
        iframe.src = src;
        iframe.allow = 'autoplay; fullscreen; picture-in-picture';
        iframe.allowFullscreen = true;
        iframe.title = btn.getAttribute('aria-label') || 'Video';
        box.appendChild(iframe);
        box.classList.add('is-playing');
      }
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
